import { create } from 'zustand';
import { User } from '@/pages/NewAdminConsole/services/permissionApi';

interface AssignUserState {
  // 对话框显示状态
  showAssignDialog: boolean;

  // 待分配的用户列表
  assigningUsers: User[];

  // 选中的部门路径
  assigningDept: string;

  // 选中的权限角色ID
  assigningPermission: string;

  // 可分配的角色列表
  assignableRolesForAssign: any[];

  // 确认分配回调
  onConfirmAssign: (assignedUsers: any[]) => void | Promise<void>;

  // Actions
  openDialog: (users: User[], onConfirm: (assignedUsers: any[]) => void | Promise<void>) => void;
  closeDialog: () => void;
  setAssigningDept: (dept: string) => void;
  setAssigningPermission: (permission: string) => void;
  setAssignableRoles: (roles: any[]) => void;
  reset: () => void;
}

const initialState = {
  showAssignDialog: false,
  assigningUsers: [],
  assigningDept: '',
  assigningPermission: '',
  assignableRolesForAssign: [],
  onConfirmAssign: () => {},
};

export const useAssignUserStore = create<AssignUserState>((set) => ({
  ...initialState,

  // 打开对话框
  openDialog: (users: User[], onConfirm: (assignedUsers: any[]) => void | Promise<void>) => {
    set({
      assigningUsers: users,
      onConfirmAssign: onConfirm,
      showAssignDialog: true,
    });
  },

  // 关闭对话框
  closeDialog: () => {
    set((state) => ({
      showAssignDialog: false,
      assigningDept: '',
      assigningPermission: state.assignableRolesForAssign.find((r) => r.code === 'ROLE_VIEWER')?.id.toString() || '',
    }));
  },

  // 设置选中的部门
  setAssigningDept: (dept: string) => set({ assigningDept: dept }),

  // 设置选中的权限
  setAssigningPermission: (permission: string) => set({ assigningPermission: permission }),

  // 设置可分配角色列表
  setAssignableRoles: (roles: any[]) =>
    set((state) => ({
      assignableRolesForAssign: roles,
      // 如果当前没有选中权限，默认选中 Viewer
      assigningPermission:
        state.assigningPermission || roles.find((r) => r.code === 'ROLE_VIEWER')?.id.toString() || '',
    })),

  // 重置所有状态
  reset: () =>
    set({
      showAssignDialog: false,
      assigningUsers: [],
      assigningDept: '',
      assigningPermission: '',
      assignableRolesForAssign: [],
      onConfirmAssign: () => {},
    }),
}));
